import { OutlinedSelectOptionType } from '@octano/global-ui';
import { Section } from '../../../api/requests/teacherPortal';
import { SecureResponseFile } from '../../../components/AzureFilesUploader/types';
import { OptionTypeIcon } from '../../../components/SelectedWithIcon/IconOption';

export interface FormValues {
  sectionId: OutlinedSelectOptionType | null;
  classStatus: OutlinedSelectOptionType | null;
}

export interface TeacherAttendanceFile extends SecureResponseFile {
  isFromAdmin: boolean;
}

export interface TeacherAttendance {
  responsible: string;
  school: string;
  course: string;
  section: string;
  date: string;
  initModule: string;
  endModule: string;
  status: string;
  justification: boolean;
  justificationState: boolean;
  viewMore: string;
  hasJustification: boolean;
  justificationStatus?: LessonTeacherJustificationStatus;
}

export interface FormResponse {
  sections: Section[];
}

export interface TeacherAttendanceLoaderQuery {
  items: number;
  page: number;
  sectionId?: number;
  classStatus?: string;
}

export interface TeacherAttendanceResponse {
  lessons: TeacherAttendance[];
  pagination: {
    totalItems: number;
    totalPages: number;
  };
}

export enum LessonTeacherJustificationStatus {
  Pending = 'pending',
  Approved = 'approved',
  Rejected = 'rejected',
}

export const statusBackgroundColorMapLessonTeacher = {
  [LessonTeacherJustificationStatus.Pending]: '#FFE6A1',
  [LessonTeacherJustificationStatus.Approved]: '#CEF0DA',
  [LessonTeacherJustificationStatus.Rejected]: '#F2C0BD',
};

export const statusColorMapLessonTeacher = {
  [LessonTeacherJustificationStatus.Pending]: 'info',
  [LessonTeacherJustificationStatus.Approved]: 'success',
  [LessonTeacherJustificationStatus.Rejected]: 'danger',
};

export const statusIconMapLessonTeacher = {
  [LessonTeacherJustificationStatus.Pending]: 'success',
  [LessonTeacherJustificationStatus.Approved]: 'success',
  [LessonTeacherJustificationStatus.Rejected]: 'error',
};

export const optionsSelectLessonTeacher: OptionTypeIcon[] = [
  { value: LessonTeacherJustificationStatus.Pending, label: 'En proceso' },
  { value: LessonTeacherJustificationStatus.Approved, label: 'Aprobada' },
  { value: LessonTeacherJustificationStatus.Rejected, label: 'Rechazada' },
];

export interface LessonTeacherJustificationFormData {
  lessonId: number;
  teacherId: number;
  description: string;
  status: LessonTeacherJustificationStatus;
  fileIds: number[];
}

export interface LessonTeacherJustificationSubmitData {
  lessonId: number;
  description: string;
  fileIds: number[];
}
